export const SITE_URL = "https://frederico.phd";
export const DEFAULT_TITLE = "Frederico Schardong, PhD";
export const DEFAULT_DESCRIPTION = "Frederico Schardong, PhD. Professor at the Federal University of Santa Catarina, working on digital identity, authentication protocols, identity federation, digital signatures, and applied research.";
export const DEFAULT_IMAGE = `${SITE_URL}/favicon/android-chrome-512x512.png`;

function upsertMeta(selector, attributes) {
  let element = document.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
}

function setCanonical(url) {
  let canonicalLink = document.querySelector('link[rel="canonical"]');

  if (!canonicalLink) {
    canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    document.head.appendChild(canonicalLink);
  }

  canonicalLink.setAttribute("href", url);
}

// Each language version is its own canonical URL, cross-referenced by hreflang, and the bare
// path is the x-default for readers whose language we cannot guess.
export function updateLanguageAlternates(path, language) {
  const alternates = [
    ["en", `${SITE_URL}${path}?lang=en`],
    ["pt-BR", `${SITE_URL}${path}?lang=pt-BR`],
    ["x-default", `${SITE_URL}${path}`],
  ];

  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((link) => link.remove());

  alternates.forEach(([hreflang, href]) => {
    const link = document.createElement("link");
    link.setAttribute("rel", "alternate");
    link.setAttribute("hreflang", hreflang);
    link.setAttribute("href", href);
    document.head.appendChild(link);
  });

  upsertMeta('meta[property="og:locale"]', {
    property: "og:locale",
    content: language === "pt-BR" ? "pt_BR" : "en_US",
  });
}

export function updatePageMetadata({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  language,
}) {
  const url = language ? `${SITE_URL}${path}?lang=${language}` : `${SITE_URL}${path}`;

  document.title = title;
  setCanonical(url);

  upsertMeta('meta[name="description"]', {
    name: "description",
    content: description,
  });

  upsertMeta('meta[property="og:title"]', {
    property: "og:title",
    content: title,
  });
  upsertMeta('meta[property="og:description"]', {
    property: "og:description",
    content: description,
  });
  upsertMeta('meta[property="og:type"]', {
    property: "og:type",
    content: type,
  });
  upsertMeta('meta[property="og:url"]', {
    property: "og:url",
    content: url,
  });
  upsertMeta('meta[property="og:image"]', {
    property: "og:image",
    content: image,
  });

  upsertMeta('meta[name="twitter:card"]', {
    name: "twitter:card",
    content: "summary_large_image",
  });
  upsertMeta('meta[name="twitter:title"]', {
    name: "twitter:title",
    content: title,
  });
  upsertMeta('meta[name="twitter:description"]', {
    name: "twitter:description",
    content: description,
  });
  upsertMeta('meta[name="twitter:image"]', {
    name: "twitter:image",
    content: image,
  });
}
